import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-muted fw-bold me-1 w-100",
  style: {"min-width":"fit-content"}
}, " Năm làm việc: ", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  selected: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("select", {
          class: "form-select form-select-solid",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeYearHandler && _ctx.changeYearHandler(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSelectableYear, (year) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: year }, [
              (year !== +_ctx.currentYear)
                ? (_openBlock(), _createElementBlock("option", {
                    key: 0,
                    value: year
                  }, _toDisplayString(year), 9, _hoisted_4))
                : (_openBlock(), _createElementBlock("option", _hoisted_5, _toDisplayString(year), 1))
            ], 64))
          }), 128))
        ], 32)
      ])
    ], 2)
  ]))
}